<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="'over'" [name]="'mainNavigation'"
        [navigation]="navigation?.default" [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            @if(view.site) {
            <div class="flex items-center h-20 pt-6 px-8">
                <img class="w-24" [src]="view.site?.logoUrl" alt="Logo image">
            </div>
            }
        </ng-container>
    </fuse-vertical-navigation>
    <fuse-vertical-navigation class=" bg-primary-300 print:hidden" [mode]="'over'" [name]="'B2CNavigation'"
        [navigation]="navigation?.horizontal" [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            @if(view.site) {
            <div class="flex items-center h-20 pt-6 px-8">
                <img class="w-24" [src]="view.site?.logoUrl" alt="Logo image">
            </div>
            }
        </ng-container>
    </fuse-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto items-center w-full min-w-0 bg-primary-100 dark:bg-primary-700">

    <!-- Header -->
    @if (view.isClient) {

    <div class="relative flex justify-center w-full overflow-hidden z-49 bg-primary-500 print:hidden client-version">
        <div
            class="max-w-360 w-full sm:m-8 sm:mb-0 md:mt-12 sm:rounded-t-xl border-b sm:shadow-2xl overflow-hidden bg-card">
            <!-- Top bar -->
            <div class="relative flex justify-between items-center h-12 bg-primary-100">
                <!-- Navigation medium to large screens-->
                <ng-container *ngIf="!isScreenSmall">
                    <div class="flex flex-auto justify-between divide-x divide-slate-200">
                        <!-- <div class="flex" *ngIf="view.site?.emailAddress">
                                <div class="flex">
                                    <div class="flex ">
                                    
                                        <div class="flex items-center justify-center w-6 h-6 bg-primary-500 rounded-md mr-3">
                                            <mat-icon class="icon-size-4 text-white" [svgIcon]="'mat_solid:email'"></mat-icon>
                                        </div>
                                    </div>
                                <div>
                                </div>
                                    <div class="border-solid border-l-2 border-primary-300 pl-4 ">
                                        <p class="text-primary-400 font-bold" >{{view.site?.emailAddress}}</p>
                                    </div>
                                </div>
                            </div> -->
                        <div *ngIf="view.site?.address">
                            <li class="ml-4 flex items-center group">
                                <div class="flex items-center justify-center w-6 h-6 bg-primary-500 rounded-md mr-3">
                                    <mat-icon class="icon-size-4 text-white"
                                        [svgIcon]="'mat_solid:location_on'"></mat-icon>
                                </div>
                                <div>
                                    <p class="text-gray-600">{{view?.site.address}}</p>
                                </div>
                            </li>
                        </div>
                        <section>
                            <div *ngIf="view?.site" class="flex">
                                @if(view.site?.socialUrlFacebook) {
                                <div class="icons">
                                    <a href="{{view.site?.socialUrlFacebook}}" target="_blank"
                                        class="group relative w-6 h-6 mr-5  transition-all duration-500 flex justify-center items-center  hover:bg-primary-100">
                                        <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                            [svgIcon]="'feather:facebook'"></mat-icon>
                                    </a>
                                </div>
                                }
                                @if(view.site?.socialUrlInstagram) {
                                <div class="icons">
                                    <a href="{{view.site?.socialUrlInstagram}}" target="_blank"
                                        class="group relative w-6 h-6 mr-5 transition-all duration-500 flex justify-center items-center  hover:bg-primary-100">
                                        <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                            [svgIcon]="'feather:instagram'"></mat-icon>
                                    </a>
                                </div>
                                }
                                @if(view.site?.socialUrlLinkedIn) {
                                <div class="icons">
                                    <a href="{{view.site?.socialUrlLinkedIn}}" target="_blank"
                                        class="group relative w-6 h-6 mr-5  transition-all duration-500 flex justify-center items-center  hover:bg-primary-100">
                                        <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                            [svgIcon]="'feather:linkedin'"></mat-icon>
                                    </a>
                                </div>
                                }
                            </div>
                        </section>

                    </div>
                </ng-container>
                <!-- Navigation small screens-->
                <ng-container *ngIf="isScreenSmall">
                    <div>
                        @if (!view.isClient) {
                        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                        </button>
                    }
                        @if (view.isClient) {
                            <button mat-icon-button (click)="toggleNavigationB2C('B2CNavigation')">
                                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                            </button>
                        }
                    </div>
                    <div *ngIf="view?.site" class="flex">
                        @if(view.site?.socialUrlFacebook) {
                        <div class="icons">
                            <a href="{{view.site?.socialUrlFacebook}}" target="_blank"
                                class="group relative w-6 h-6 mr-5  transition-all duration-500 flex justify-center items-center  hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:facebook'"></mat-icon>
                            </a>
                        </div>
                        }
                        @if(view.site?.socialUrlInstagram) {
                        <div class="icons">
                            <a href="{{view.site?.socialUrlInstagram}}" target="_blank"
                                class="group relative w-6 h-6 mr-5 transition-all duration-500 flex justify-center items-center  hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:instagram'"></mat-icon>
                            </a>
                        </div>
                        }
                        @if(view.site?.socialUrlLinkedIn) {
                        <div class="icons">
                            <a href="{{view.site?.socialUrlLinkedIn}}" target="_blank"
                                class="group relative w-6 h-6 mr-5  transition-all duration-500 flex justify-center items-center  hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:linkedin'"></mat-icon>
                            </a>
                        </div>
                        }
                    </div>
                </ng-container>
            </div>
            <!-- Bottom bar -->
            <ng-container *ngIf="!isScreenSmall">
                <div class=" flex flex-auto  items-center h-20 px-4 justify-between">
                    <div class="flex items-center mx-2 w-72">
                        <a routerLink="/" class="flex items-center">
                            @if(view.site) {
                            @if(view.site?.id == 63) {
                            <div class="flex items-center p-2" style="max-width: 65%">
                                <img class="w-24" [src]="view.site?.logoUrl2" alt="Logo image">
                            </div>
                            <div class="hidden lg:flex items-center" style="max-width: 65%">
                                <span class="text-center text-md mx-3">Powered By:</span>
                                <img class="w-40" src="assets/xltravel/members/XL MEMBER LOGOS-21.png?v=2" alt="Logo image">
                            </div>
                            }
                            @if(view.site?.id != 63) {
                            <div class="flex items-center">
                                <img class="" style="max-width: 65%" [src]="view.site?.logoUrl" alt="Logo image">
                            </div>
                            }
                            }
                        </a>
                    </div>
                    <div>
                        <fuse-horizontal-navigation *ngIf="navigation && navigation.horizontal"
                            [name]="'mainNavigation'" [navigation]="navigation.horizontal"></fuse-horizontal-navigation>
                    </div>
                    <div class="flex w-72">
                        <div class="flex pt-2">
                            <div *ngIf="view.site?.telephone"
                                class="flex items-center justify-center w-6 h-6 bg-primary-500 rounded-md mr-3">
                                <mat-icon class="icon-size-4 text-white" [svgIcon]="'mat_solid:local_phone'"></mat-icon>
                            </div>
                            <div *ngIf="view.site?.emailAddress"
                                class="flex items-center justify-center w-6 h-6 bg-primary-500 rounded-md mr-3">
                                <mat-icon class="icon-size-4 text-white" [svgIcon]="'mat_solid:email'"></mat-icon>
                            </div>
                        </div>
                        <div class="border-solid border-l-2 border-primary-300 pl-4 mt-1">
                            <div *ngIf="view.site?.telephone">
                                <p class="text-primary-600 font-bold text-sm">{{ view.site?.telephone }}</p>
                            </div>
                            <div class="cursor-pointer" *ngIf="view.site?.emailAddress" (click)="sendEmail(view.site?.emailAddress)">
                                <p class="text-gray-400 text-sm">{{view.site?.emailAddress}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    }

    @if (!view.isClient) {
    <div class="relative flex justify-center w-full overflow-hidden z-49 bg-primary-700 print:hidden">
        <div
            class="max-w-360 w-full sm:py-3 sm:m-8 sm:mb-0 md:mt-12 md:mx-8 md:pt-4 md:pb-3 sm:rounded-t-xl border-b sm:shadow-2xl overflow-hidden bg-card">
            <!-- Top bar -->
            <div class="relative flex flex-auto items-center h-16 px-4 md:px-6">
                <!-- Logo -->
                <ng-container *ngIf="!isScreenSmall">
                    <div class="flex items-center mx-2">
                        <!-- Light version -->
                        <img class="w-24 dark:hidden" src="assets/images/logo/logo-text.svg" alt="Logo image">
                        <!-- Dark version -->
                        <img class="hidden dark:flex w-24" src="assets/images/logo/logo1.png" alt="Logo image">
                    </div>
                </ng-container>
                <!-- Navigation toggle button -->
                <ng-container *ngIf="isScreenSmall">
                    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                    </button>
                    <search></search>
                </ng-container>
                <!-- Components -->
                <div class="flex items-center pl-2 ml-auto space-x-1 sm:space-x-2">
                    <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                    <shortcuts></shortcuts>
                    <messages></messages>
                    <user [showSummary]="true"></user>
                </div>
            </div>
            <!-- Bottom bar -->
            <ng-container *ngIf="!isScreenSmall">
                <div class="relative flex flex-auto items-center h-16 px-4">
                    <fuse-horizontal-navigation [name]="'mainNavigation'"
                        [navigation]="navigation.horizontal"></fuse-horizontal-navigation>
                </div>
            </ng-container>
            <ng-container *ngIf="isScreenSmall">
                <button mat-icon-button (click)="toggleNavigationB2C('B2CNavigation')">
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
                <!-- <search></search> -->
            </ng-container>
        </div>
    </div>
    }

    <!-- Content -->
    <div class="flex flex-auto justify-center w-full sm:px-8">
        <div class="flex flex-col flex-auto w-full sm:max-w-360 sm:shadow-xl sm:overflow-hidden bg-default">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
            <!-- Dynamic cart section -->
            @if (view.isClient && view.data.cart && view.data.cart.length > 0) {
            <mat-drawer
                class="m-auto dark:bg-gray-900 transition-all duration-500 fixed bottom-0 shadow-2xl w-[90%] bg-white pb-5 z-99 rounded-t-lg border-2 border-b-0 border-primary opacity-[97]"
                [position]="'end'" [autoFocus]="false"
                [mode]="view.drawerOptions && view.drawerOptions.mode == 'review' ? 'side' : drawerMode"
                [disableClose]="false" [opened]="view.data.cart && view.data.cart.length > 0" #drawerRight>
                <cart [options]="{loadCache:false, isClient:view.isClient, compactColumns: true}" (viewChange)="viewChanged($event)"
                    (quoteCreated)="quoteCreated($event)"></cart>
            </mat-drawer>
            }

            @if (view.isClient) {
            @if (view.site && view.site.profile && view.site.profile.sections) {
            @switch (view.site.profile.sections.footer ) {
            @case (1) {
            <app-footer-type01 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type01>
            }
            @case (2) {
            <app-footer-type02 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type02>
            }
            }
            }
            }
        </div>
    </div>
</div>
